<template>
  <div class="py-6 px-2 flex flex-col gap-4 main-off-white">
    <PainelComercialHeader
      v-if="true"
      :isAnnualPodium="isAnnualPodium"
      :initialDate="initialDate"
      :finalDate="finalDate"
      :key="`${finalDate}-${initialDate}`"
      :isLoading="isLoading"
    />
    <DynamicMenu
      ref="dynamicMenu"
      @toggle-full-screen="handleFullScreen"
      @change-view="handleChangeView"
      :current-item-id="currentItemId"
      :class="{ hidden: isPresentationMode, flex: !isPresentationMode }"
    />

    <div
      :class="{ block: isPresentationMode, hidden: !isPresentationMode }"
      class="mb-4"
    ></div>

    <component
      :is="currentView"
      :key="`currentView-${currentViewKey}-${finalDate}-${initialDate}-${isPresentationMode}`"
      :initialDate="initialDate"
      :finalDate="finalDate"
      :is-presentation-mode="isPresentationMode"
    />
  </div>
</template>

<script>
import PainelComercialHeader from '../PainelComercial/components/PainelComercialHeader.vue';
import DynamicMenu from './components/DynamicMenu.vue';
import { EventBus } from '../../../utils/eventBus';
import PainelGeral from './views/PainelGeralView';
import { menuDynamic } from './utils/menu-dynamic';

export default {
  name: 'RankingRegisterView',
  components: { PainelComercialHeader, DynamicMenu },

  data() {
    const currentDate = new Date();
    const startOfMonth = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1,
    ).padStart(2, '0')}-01`;
    return {
      currentView: null,
      currentViewIndex: 0,
      currentViewName: '',
      currentItemId: '',
      currentViewKey: 0,
      isPresentationMode: false,
      isAnnualPodium: true,
      isLoading: false,
      seletectedDateInitial: startOfMonth,
      selectedDateFinal: currentDate.toISOString().substring(0, 10),
    };
  },
  computed: {
    initialDate() {
      return this.seletectedDateInitial;
    },
    finalDate() {
      return this.selectedDateFinal;
    },
  },
  methods: {
    handleDateChange(dates) {
      if (dates.startDate !== this.seletectedDateInitial) {
        this.seletectedDateInitial = dates.startDate;
        this.isLoading = true;
      }
      if (dates.endDate !== this.selectedDateFinal) {
        this.selectedDateFinal = dates.endDate;
        this.isLoading = true;
      }
    },
    handleChangeView(viewName) {
      if (!viewName) {
        return;
      }
      this.currentViewKey++;
      this.currentViewName = viewName;
      const views = {
        PainelGeral,
      };
      this.isLoading = true;
      this.currentView = views[viewName] || null;
    },
    handleFullScreen() {
      if (document.fullscreenElement) {
        this.exitPresentationMode();
        return;
      }

      this.enterPresentationMode();

      if (this.currentViewName === 'PainelGeral') {
        this.advanceToNextView();
      }
    },
    enterPresentationMode() {
      this.$el.requestFullscreen().then(() => {
        this.isPresentationMode = true;
        this.startPresentationMode();
      });
    },
    exitPresentationMode() {
      document.exitFullscreen().then(() => {
        this.isPresentationMode = false;
        this.stopPresentationMode();
      });
    },
    handleFullscreenChange() {
      if (!document.fullscreenElement) {
        this.isPresentationMode = false;
        this.stopPresentationMode();
      }
    },
    startPresentationMode() {
      this.stopPresentationMode();
      const PRESENTATION_MODE_INTERVAL_MS = 30000;

      this.presentationModeInterval = setInterval(() => {
        if (this.isPresentationMode) {
          this.advanceToNextView();

          const { [this.currentViewIndex]: componentName } =
            this.viewComponents;

          if (componentName === 'PainelGeral') {
            this.advanceToNextView();
          }

          const selectedItem = menuDynamic.find(
            ({ componentName }) =>
              componentName === this.viewComponents[this.currentViewIndex],
          );

          if (selectedItem) {
            const { unique, text } = selectedItem;
            const identifier = unique || text;
            this.handleChangeView(this.viewComponents[this.currentViewIndex]);
            this.currentItemId = identifier;
          }
        }
      }, PRESENTATION_MODE_INTERVAL_MS);
    },
    stopPresentationMode() {
      if (this.presentationModeInterval) {
        clearInterval(this.presentationModeInterval);
        this.presentationModeInterval = null;
      }
    },
    advanceToNextView() {
      const nextViewIndex =
        (this.currentViewIndex + 1) % this.viewComponents.length;
      const nextComponentName = this.viewComponents[nextViewIndex];
      const isNextPainelGeral = nextComponentName === 'PainelGeral';
      const finalViewIndex = isNextPainelGeral
        ? (nextViewIndex + 1) % this.viewComponents.length
        : nextViewIndex;
      const finalComponentName = this.viewComponents[finalViewIndex];

      this.currentViewIndex = finalViewIndex;

      const selectedItem = menuDynamic.find(
        (item) => item.componentName === finalComponentName,
      );
      if (selectedItem) {
        this.handleChangeView(finalComponentName);
        const identifier = selectedItem.unique || selectedItem.text;
        this.currentItemId = identifier;
      }
    },
  },
  mounted() {
    this.handleChangeView('PainelGeral');
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    EventBus.$on('date-changed', this.handleDateChange);
  },
  beforeDestroy() {
    this.stopPresentationMode();
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange,
    );
    EventBus.$off('date-changed', this.handleDateChange);
  },
};
</script>

<style scoped>
.main-off-white {
  background-color: #f8f8f8;
}
</style>
